import PropTypes from 'prop-types'

import { IconProps } from './types/IconProps'

const BareQuestionIcon = ({ className, onClick }: IconProps) => (
  <svg
    width='5'
    height='8'
    viewBox='0 0 5 8'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    onClick={onClick}
  >
    <path d='M1.31836 4.87305V4.51172C1.31836 4.29036 1.34928 4.09505 1.41113 3.92578C1.47298 3.75326 1.57227 3.59049 1.70898 3.4375C1.8457 3.28125 2.02637 3.12174 2.25098 2.95898C2.4528 2.81576 2.61393 2.68717 2.73438 2.57324C2.85807 2.45931 2.94759 2.34701 3.00293 2.23633C3.06152 2.1224 3.09082 1.99382 3.09082 1.85059C3.09082 1.639 3.0127 1.47786 2.85645 1.36719C2.7002 1.25651 2.4821 1.20117 2.20215 1.20117C1.9222 1.20117 1.64388 1.24512 1.36719 1.33301C1.09375 1.4209 0.81543 1.53646 0.532227 1.67969L0 0.610352C0.325521 0.42806 0.678711 0.281576 1.05957 0.170898C1.44043 0.0569661 1.8571 0 2.30957 0C3.00618 0 3.54492 0.167643 3.92578 0.50293C4.3099 0.834961 4.50195 1.25814 4.50195 1.77246C4.50195 2.0459 4.45801 2.28353 4.37012 2.48535C4.28548 2.68392 4.15527 2.86947 3.97949 3.04199C3.80697 3.21126 3.59049 3.3903 3.33008 3.5791C3.13477 3.72233 2.98503 3.84277 2.88086 3.94043C2.77669 4.03809 2.70508 4.13574 2.66602 4.2334C2.63021 4.3278 2.6123 4.44336 2.6123 4.58008V4.87305H1.31836ZM1.16211 6.54297C1.16211 6.23698 1.24512 6.02214 1.41113 5.89844C1.5804 5.77474 1.78385 5.71289 2.02148 5.71289C2.2526 5.71289 2.45117 5.77474 2.61719 5.89844C2.78646 6.02214 2.87109 6.23698 2.87109 6.54297C2.87109 6.83594 2.78646 7.04753 2.61719 7.17773C2.45117 7.30794 2.2526 7.37305 2.02148 7.37305C1.78385 7.37305 1.5804 7.30794 1.41113 7.17773C1.24512 7.04753 1.16211 6.83594 1.16211 6.54297Z' />
  </svg>
)

BareQuestionIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default BareQuestionIcon
